import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import { format, isValid, parse } from 'date-fns';
import { Subject, takeUntil, tap, throttleTime } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-date-question',
  templateUrl: './date-question.component.html',
  styleUrls: ['./date-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DateQuestionComponent implements OnInit, OnDestroy {

  @Input() question: QQQuestionViewModel;
  @ViewChild('dateInput') dateInput: NgModel;
  @ViewChild('dd') daySelect: ElementRef<HTMLSelectElement>;
  @ViewChild('mm') monthSelect: ElementRef<HTMLSelectElement>;
  @ViewChild('yy') yearSelect: ElementRef<HTMLSelectElement>;

  days = range(31).map(x => x + 1);
  months = range(12).map(x => format(new Date(1970, x, 1), 'LLLL'));
  years = range(100 - 18).map(x => new Date().getFullYear() + 1 - x);
  day: number = null;
  month: number = null;
  year: number = null;
  save$ = new Subject();
  currentYear = new Date().getFullYear();
  date: string;
  dispose$ = new Subject();

  constructor() {
  }

  ngOnInit() {
    const date = parse(this.question.answer, 'd MMMM yyyy', 0);
    if (isValid(date)) {
      this.day = date.getDate();
      this.month = date.getMonth();
      this.year = date.getFullYear();
    }

    if (this.question.options?.DisallowFutureDates) {
      this.years = this.years.filter(year => year <= this.currentYear);
    }

    if (this.question.options?.years)
      this.years = [...this.yearRange(this.question.options.years)];

    this.save$.pipe(
      takeUntil(this.dispose$),
      throttleTime(200, null, { trailing: true, leading: false }),
      tap(x => this.doSave())
    ).subscribe();

    this.question.beforeSubmit(
      this.dispose$,
      e => {
        if (this.daySelect?.nativeElement
          && this.monthSelect?.nativeElement
          && this.yearSelect?.nativeElement
        ) {
          if (this.day?.toString() != this.daySelect.nativeElement.value
            || this.month?.toString() != this.monthSelect.nativeElement.value
            || this.year?.toString() != this.yearSelect.nativeElement.value)
            this.day = parseInt(this.daySelect.nativeElement.value);
          this.month = parseInt(this.monthSelect.nativeElement.value);
          this.year = parseInt(this.yearSelect.nativeElement.value);

          e.add(() => this.doSave());
        }
      });
  }

  ngOnDestroy(): void {
    this.dispose$.next(1);
  }

  private *yearRange(range?: { max?: number, min?: number }) {
    const start = range?.min ?? 0;
    const end = range?.max ?? 100 - 18;
    const step = start < end ? 1 : -1;
    const year = new Date().getFullYear();
    for (var i = start; i <= end; i += step) {
      yield year + i;
    }
  }

  reset() {
    //this.question.editing = false;
  }

  async doSave() {
    this.question.error = null;
    const date = new Date(this.year, this.month, this.day);
    if (!this.year || !this.month || !this.day || !isValid(date) || date.getMonth() != this.month) {
      this.question.error = 'Please choose a valid date';
      return false;
    } else {
      const value = format(date, 'd MMMM yyyy');
      if (this.question.answer != value)
        return await this.question.setAnswer(value, true);
      else
        return true;
    }
  }

  async checkSave() {
    if (this.year !== null && this.month !== null && this.day !== null)
      await this.save$.next(null);
  }
}

function range(count: number): number[] {
  return [...new Array(count).keys()];
}
